import { useAsset } from '@artica/assets';
import { Visible } from '@immutabl3/alchemy';
import { parallax } from '@immutabl3/alchemy/three';
import animation from './competitionCardFG.animation.json';
import { AdditiveBlending } from 'three';

const CompetitionCardFG = function() {
  const video = useAsset('compcards_fg');
  return (
    <parallax.spriteMaterial
      beaker="chapter1"
      animation={ animation }

      attach="material"
      blending={ AdditiveBlending }
      color={ [2, 2, 2] }
      fog={ false }
      map={ video }
      sizeAttenuation
      transparent
    />
  );
};

export default function CompetitionCardFGContainer({ position }) {
  return (
    <Visible beaker="chapter1" animation={ animation }>
      <sprite
        scale={ 25 }
        position={ position }
      >
        <CompetitionCardFG />
      </sprite>
    </Visible>
  );
};